const VIEW_PDF = 'View PDF';
const VIEW_TANDC = 'View Terms and Conditions';
const EXPORT = 'Export';
const CHECK = 'Check';
const VALIDATE = 'Validate';

export { VIEW_PDF, VIEW_TANDC, EXPORT, CHECK, VALIDATE };
